import React, { ReactElement } from "react";

import classNames from "classnames";

import "./statusTag.scss";

interface StatusTagProps {
  text?: string;
  variant?:
    "primary"
    | "secondary"
    | "tertiary"
    | "indication";
  icon: ReactElement;
}

const StatusTag: React.FC<StatusTagProps> = ({
  text = undefined,
  variant = undefined,
  icon,
}) => (
  <div className="status-tag-wrapper">
    {icon}
    {text && (
      <div
        className={classNames(
          "status-tag",
          variant && `status-tag--${variant}`,
        )}
      >
        {text}
      </div>
    )}
  </div>
);

export default StatusTag;
